import type { Ref } from "react";
import { ScrollView, type ScrollViewProps } from "react-native";
type KeyboardAwareExtras = {
  bottomOffset?: number;
  extraKeyboardSpace?: number;
  disableScrollOnKeyboardHide?: boolean;
  enabled?: boolean;
  ref?: Ref<ScrollView>;
};

/**
 * Web stub for KeyboardAwareScrollView. On native, this is replaced by the
 * react-native-keyboard-controller version (KeyboardAwareScrollView.native.tsx),
 * which auto-scrolls a focused input above `bottomOffset` when the keyboard
 * appears. On web, soft keyboards don't overlap content, so the keyboard-aware
 * props are accepted-and-ignored and we render a plain ScrollView.
 */
export const KeyboardAwareScrollView = ({
  bottomOffset: _bottomOffset,
  extraKeyboardSpace: _extraKeyboardSpace,
  disableScrollOnKeyboardHide: _disableScrollOnKeyboardHide,
  enabled: _enabled,
  ...rest
}: ScrollViewProps & KeyboardAwareExtras) => <ScrollView {...rest} data-sentry-element="ScrollView" data-sentry-component="KeyboardAwareScrollView" data-sentry-source-file="KeyboardAwareScrollView.tsx" />;